module.exports = __webpack_public_path__ + "static/media/A10.c9622b28.mp3";